import React from 'react'
import { Translation } from '@morningtrain/react-translations'
import SmartviewContentSection from 'widgets/smartviews/partials/SmartviewContentSection'
import { ForEachModel, useValue, ValueToCollection, WhenModelValue } from '@morningtrain/react-resources'
import * as Displays from 'support/displays'
import * as UI from 'ui'
import EditEmploymentForm from 'pages/app/hr/employments/partials/EditEmploymentForm'
import WhenEmploymentIsDraft from 'pages/app/hr/employments/partials/WhenEmploymentIsDraft'
import AvatarWrapper from 'ui/partials/AvatarWrapper'
import SmartviewContentSeparator from 'widgets/smartviews/partials/SmartviewContentSeparator'
import EmploymentSmartviewWrapper from 'pages/app/hr/employments/smartviews/EmploymentSmartviewWrapper'

export default function EmploymentSmartviewInner ({ create = false }) {
  const status = useValue('status')
  const size = (!status || status === 'draft') ? '3xl' : 'xs'

  return (
    <EmploymentSmartviewWrapper create={create} size={size} showFooter={!create}>
      <WhenModelValue name="id">
        <SmartviewContentSection>
          <div className="flex">
            <AvatarWrapper>
              <Displays.Image name="user.avatar_url"/>
            </AvatarWrapper>
            <div className="flex flex-col">
              <div className="font-medium text-lg leading-tight">
                <Displays.Text name="user.name"/>
              </div>
            </div>
          </div>
          <div className="flex flex-col">
            <SmartviewContentSeparator className="my-4"/>
            <div className="text-sm leading-tight">
              <span>Status</span>
              <span>: </span>
              <Displays.Enum
                enum="detailed_employment_status"
                name="detailed_status"
              />
            </div>
            <SmartviewContentSeparator className="my-4"/>
            <UI.SpaceBetween>
              <div className="text-sm leading-tight">
                <Translation name="titles.danish_citizen"/>
                <span>: </span>
                <WhenModelValue name="user.is_danish_citizen" condition>
                  <Translation name="generic.yes"/>
                </WhenModelValue>
                <WhenModelValue name="user.is_danish_citizen" condition={false}>
                  <Translation name="generic.no"/>
                </WhenModelValue>
              </div>
              <div className="space-x-2 flex">
                <ValueToCollection name="user.work_permit_files">
                  <ForEachModel>
                    <Displays.Link name="url">
                      <UI.Icons.Download/>
                    </Displays.Link>
                  </ForEachModel>
                </ValueToCollection>
              </div>
            </UI.SpaceBetween>
            <SmartviewContentSeparator className="my-4"/>
            <div className="text-sm leading-tight">
              <Translation name="titles.employment_date"/>
              <span>: </span>
              <Displays.Date name="user.hired_at"/>
            </div>
            <SmartviewContentSeparator className="my-4"/>
          </div>
        </SmartviewContentSection>
      </WhenModelValue>

      <WhenEmploymentIsDraft negate>

        <div>
          <UI.Text block className="border-b mb-3 border-gray-200">
            <Translation name="fields.salary_steps.label"/>
          </UI.Text>
          <UI.VerticalList border>
            <ValueToCollection name="salary_steps">
              <ForEachModel>
                <UI.SpaceBetween>
                  <UI.Text size="xs" weight="medium">
                    <Displays.Enum enum="salary_period_offset" name="salary_period_offset"/>
                  </UI.Text>
                  <UI.Text size="xs" weight="medium">
                    <Displays.Currency name="amount"/>
                    <span> / </span>
                    <WhenModelValue name="type" condition="hourly">
                      <Translation name="generic.time_single.hours"/>
                    </WhenModelValue>
                    <WhenModelValue name="type" condition="monthly">
                      m
                    </WhenModelValue>
                  </UI.Text>
                </UI.SpaceBetween>
              </ForEachModel>
            </ValueToCollection>
          </UI.VerticalList>
        </div>

      </WhenEmploymentIsDraft>
      <WhenEmploymentIsDraft>
        <SmartviewContentSection>
          <EditEmploymentForm/>
        </SmartviewContentSection>
      </WhenEmploymentIsDraft>
    </EmploymentSmartviewWrapper>
  )
}
